import script from "./FileDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./FileDropdown.vue?vue&type=style&index=0&id=1dee52d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dee52d6"]])

export default __exports__